import React from 'react';
import { useNavigate } from 'react-router-dom';
import URL from '@/common/routes/Url';
import './css/sctStyle.scss';

const Sct: React.FC = () => {
  const navigate = useNavigate();

  const tologin = () => {
    navigate(URL.privacy);
  }

  return (
    <div className='sct'>
      <header>
        <h1 className="ttl">
          <img src="/manual/sample/images/logo.png" alt="次世代ホワイトボード みてリンク" />
        </h1>
        <ul className="list">
          <li>
            <a href="/signin">ログイン</a>
          </li>
          <li>
            <a href="/home">ホーム</a>
          </li>
          <li>
            <a href="https://si.mitani-corp.co.jp/lp/mitelink-form/">
              お問い合わせ
            </a>
          </li>
          <li>
            <a href="/home/privacy">プライバシーポリシー</a>
          </li>
          <li>
            <a href="/manual/terms.pdf" target='_blank'>
              利用規約
            </a>
          </li>
        </ul>
      </header>
      <body>
        <h2>特定商取引法に基づく表記</h2>
        <table>
          <tbody>
            <tr>
              <th>販売業者</th>
              <td>三谷商事株式会社 情報システム事業部 システム部</td>
            </tr>
            <tr>
              <th>代表者または運営統括責任者名</th>
              <td>渡邉 伊保</td>
            </tr>
            <tr>
              <th>所在地</th>
              <td>〒910-8510　福井県福井市豊島1-3-1 第3三谷ビル</td>
            </tr>
            <tr>
              <th>電話番号</th>
              <td><a href="tel:0120-188-022">0120-188-022</a></td>
            </tr>
            <tr>
              <th>メールアドレス</th>
              <td><a href="mailto:mitelink@mitani-corp.co.jp">mitelink@mitani-corp.co.jp</a></td>
            </tr>
            <tr>
              <th>営業時間</th>
              <td>月～金曜日　9:00～12:00 13:00～17:00（祝日、年末年始等は除く）</td>
            </tr>
            <tr>
              <th>商品代金以外に必要な費用</th>
              <td>消費税、振込手数料</td>
            </tr>
            <tr>
              <th>代金の支払時期および方法</th>
              <td>銀行振込の場合、請求書の到着後ご入金ください。<br/>口座引落の場合、当月利用分を翌月20日に銀行口座から引き落とされます。</td>
            </tr>
            <tr>
              <th>返品・解約</th>
              <td>商品の性質上、ご契約後の返金・返品はできかねます。<br/>解約については、<a href="mailto:mitelink@mitani-corp.co.jp">mitelink@mitani-corp.co.jp</a> 宛に<br/>「会社名・管理者名・解約希望日」を記載下さい。</td>
            </tr>
          </tbody>
        </table>
      </body>
      <footer>
        <div className="infoWrap">
          <div className="flex">
            <div className="box">
              <img src="/manual/sample/images/ftr_logo.png" alt="三谷商事株式会社" />
              <img src="/manual/sample/images/ftr_name.png" alt="情報システム事業部システム部" />
            </div>
            <div className="box2">
              <div className="info">
                <img src="/manual/sample/images/ftr_icon_phone.png" alt="フリーダイヤル" />
                <a href="tel:0120-188-022">0120-188-022</a>
              </div>
              <div className="info2">受付時間 9:00-12:00 13:00-17:00</div>
              <div className="info3">
                <img src="/manual/sample/images/ftr_icon_mail.png" alt="メールアドレス" />
                <a href="mailto:mitelink@mitani-corp.co.jp">
                  mitelink@mitani-corp.co.jp
                </a>
              </div>
            </div>
          </div>
          <div className='footer'>
            <ul className="md-flex">
            <li><a href="/home">ホーム</a></li>
              <li className='ll'><a href="/home/overview">会社概要</a></li>
              <li className='ll'><a href="/home/sct">特定商取引法に基づく表記</a></li>
              <li className='ll'><a href="/home/privacy">プライバシーポリシー</a></li>
              <li className='ll'><a href="/manual/terms.pdf" target='_blank'>利用規約</a></li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  );
}
export default Sct;